<template>
  <div class="product-page ggt-page">
    <div class="productBar">
      <div class="auto">
        <h2>产品：大智慧港股通<span>非投资咨询类软件产品</span></h2>
      </div>
    </div>
    <div class="page-header ggt-header-new">
      <div class="innerwrap">
        <img src="../../assets/images/product/100/banner01.jpg" alt="">
      </div>
    </div>
    <div class="main">
      <div class="row1 row">
        <div class="block">
          <div class="left-block">
            <img src="../../assets/images/product/100/img01.jpg" alt="">
          </div>
          <div class="right-block">
            <h3>沪港深三地Level-2实时行情</h3>
            <p>逐笔交易、十档/千档买卖盘。专线连接三大交易所，为您提供全面、高速、稳定的交易行情。</p>

            <h4 class="mt30"><span class="num">1</span><span style="font-size: 16px;font-weight: normal;">专线连接沪深港三地交易所，行情快</span></h4>

            <h4><span class="num">2</span><span style="font-size: 16px;font-weight: normal;">全面覆盖沪深港所有交易品种 </span></h4>
          </div>

        </div>
      </div>
      <div class="row2 row">
        <div class="bg">
        <div class="innerwrap">
          <h3>一线港股权威资讯</h3>

          <div class="content-pic">
            <img src="../../assets/images/product/100/img02.jpg" alt="">
          </div>
          <div class="block">
            <div class="block-item">
              <h4><span class="num">1</span>阿斯达克一线资讯 </h4>
              <p>强大的咨询团队，7*24小时提供前沿的亚太市场资讯。</p>
            </div>
            <div class="block-item">
              <h4><span class="num">2</span>专业港股F10</h4>
              <p>提供全面的上市公司财务信息。</p>
            </div>
            <div class="block-item">
              <h4><span class="num">3</span>研究报告</h4>
              <p>提供各大研究机构多维度、多层次的宏观、行业、上司公司研报成果。</p>
            </div>
            <div class="block-item">
              <h4><span class="num">4</span>港股新闻及公告</h4>
              <p>快速了解当天发布新闻和公司的上市公司。</p>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row3 row row-hasline">
        <h3>港股分析系统</h3>
        <p>港股行情分析系统在定位分析、叠加分析、相关性分析、画线分析、AH比价分析等分析工具，基于港交所L2数据基础上研发了经济席位追踪和大单过滤功能。</p>
        <div class="content-pic"><img src="../../assets/images/product/100/img03.jpg" alt=""></div>
        <div class="block">
          <div class="block-item">
            <h4><span class="num">1</span>经济席位追踪</h4>
            <p>对机构席位进行跟踪剖析，实时揭示明星席位成交记录。</p>
          </div>
          <div class="block-item">
            <h4><span class="num">2</span>概念分类板块</h4>
            <p>结合大智慧F10、财汇数据、阿斯达克新闻资讯整理港股概念板块，提高AH股联动概念</p>
          </div>
          <div class="block-item last">
            <h4><span class="num">3</span>AH比价分析</h4>
            <p>鉴于中国上市公司有A股、H股股票类型的区分，以及两者之间天然存在的联动性，“比价分析”提供了一个研究A+H股股价联动以及溢价水平的分析平台。</p>
          </div>
        </div>
      </div>
      <div class="row4 row row-hasline">
        <div class="innerwrap">
          <h3>沪深市场特色功能</h3>
          <div class="content-pic"><img src="../../assets/images/product/100/img04.jpg" alt=""></div>
          <div class="block">
            <div class="block-item">
              <h4><span class="num">1</span>DDE资金流</h4>
              <p>反应真实的资金动向，把握股价涨跌</p>
            </div>
            <div class="block-item">
              <h4><span class="num">2</span>市场关注</h4>
              <p>看机构关注内容，知今日市场动向，网罗终端等各热点功能，并根据市场变化，提供更高价值的热点资讯</p>
            </div>
            <div class="block-item">
              <h4><span class="num">3</span>主题投资库</h4>
              <p>提前挖掘前瞻性题材，并可在第一时间发现并捕捉市场热点转换</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <float-bar :id="id" :month="month"/>
  </div>
</template>
<script>
import FloatBar from "@/components/product/FloatBar.vue";
export default {
  data() {
    return {
      id: this.$parent.id,
      month : 12
    };
  },
  created () {
    document.title = '大智慧港股通';
  },
  components:{
    FloatBar
  }
}
</script>
<style lang="scss" scoped>
.innerwrap {
  width: 980px;
  margin: 0 auto;
  position: relative;
  *zoom: 1;
  zoom: 1;
  &:before,&:after {
    display: table;
    content: "";
    line-height: 0;
  }
  &:after {
    clear: both;
  }
}
.product-page{
  .page-header{
    position: relative;
    img {
      display: block;
    }
    .innerwrap {
      width: 1044px;
    }
  }
  .main {
    padding-top: 98px;
    padding-bottom: 200px;
    .row {
      *zoom: 1;
      zoom: 1;
      position: relative;
      &:before,&:after {
        display: table;
        content: "";
        line-height: 0;
      }
      &:after {
        clear: both;
      }
      h3 {
        font-size: 38px;
        color: #2c466c;
        line-height: 1.6em;
        padding-bottom: 10px;
      }
      h4 {
        margin-bottom: 5px;
        font-size: 14px;
        color: #666;
        font-weight: bold;
      }
      p {
        margin-bottom: 10px;
        font-size: 14px;
        color: #666;
        text-indent: 2em;
      }
      li, ul {
        font-size: 14px;
        color: #666;
        list-style: none;
      }
       .group {
        margin-bottom: 10px;
        li {
          text-indent: 2em;
        }
      }
      .group1 {
        margin-bottom: 10px;
      }
      .left-block {
        float: left;
        width: 473px;
        position: relative;
        img {
          position: relative;
        }
      }
      .right-block {
        float: right;
        width: 473px;
        position: relative;
        img {
          position: relative;
        }
      }
    }
  }
}
.ggt-page{
  .page-header {
    background: #021686;
    .innerwrap img {
      margin: 0 auto;
    }
    .header-bottom {
      height: 121px;
      background: url(~@/assets/images/product/100/banner02.jpg) 371px top no-repeat;
    }
  }
  .ggt-header-new{
    .innerwrap{
      width: 1280px;
      margin-bottom: 125px;
    }
  }
  .main {
    padding-top: 5px;
    width: auto;
    padding-bottom: 0;
    .row{
      h3 {
        color: #2d6789;
        font-size: 30px;
      }
      p {
        color: #7d7d7d;
        font-size: 13px;
        text-indent: 0em;
      }
      h4 {
        color: #484848;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .num {
      display: inline-block;
      width: 23px;
      height: 23px;
      background: url(~@/assets/images/product/100/num.jpg);
      line-height: 22px;
      text-align: center;
      color: #fff;
      margin-right: 5px;
      font-family: Arial;
      font-size: 20PX;
      font-weight: 400;
    }
    .row1 {
      width: 990px;
      margin: 0 auto;
      padding-bottom: 70px;
      .left-block {
        width: 671px;
      }
      .right-block {
        width: 299px;
        padding-left: 20px;
        p {
          padding-bottom: 10px;
        }
        h4 {
          line-height: 6px;
        }
      }
    }
    .row2 {
      padding: 70px 0;
      background: #f4f4f4;
      h4 {
        margin-top: 30px;
      }
      .innerwrap {
        width: 1000px;
      }
      .content-pic {
        width: 845px;
        margin: 0 auto;
      }
      .block{
        .block-item {
          float: left;
          width: 190px;
          margin-right: 10px;
        }
        .last {
          margin-right: 0;
        }
      }
    }
    .row3 {
      width: 990px;
      margin: 0 auto;
      padding-top: 70px;
      padding-bottom: 50px;
      h4 {
      margin-top: 30px;
      }
      .content-pic {
        width: 870px;
        margin: 0 auto;
      }
      .block{
        .block-item {
          width: 315px;
          float: left;
          margin-right: 20px;
        }
        .last {
          margin-right: 0;
        }
      }
    }
    .row4{
      background: #f4f4f4;
      padding-bottom: 100px;
      padding-top: 70px;
      .content-pic{
        text-align: center;
      }
      .block{
        .block-item{
          width: 305px;
          float: left;
          margin-right: 20px;
        }
      }
      h4{
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/Product100.vue